/** Step bar item for Attorney General / AGD Internal only (truncated labels + full title tooltip). */
export function AttorneyGeneralWizardStep({
  state,
  numberOrCheck,
  stepLabel,
  name,
  showLabel = true,
  onClick,
}: {
  state: 'done' | 'active' | 'pending';
  numberOrCheck: string;
  stepLabel: string;
  name: string;
  showLabel?: boolean;
  onClick?: () => void;
}) {
  const wrapCls =
    state === 'done' ? 'ccr-si s-done' : state === 'active' ? 'ccr-si s-active' : 'ccr-si';

  const content = (
    <>
      <div className="ccr-sc">{numberOrCheck}</div>
      {showLabel ? (
        <div className="ccr-st">
          <div className="ccr-slbl">{stepLabel}</div>
          <div className="ccr-snm ccr-snm--truncated" title={name}>
            {name}
          </div>
        </div>
      ) : null}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={`${wrapCls} ccr-si-btn`} onClick={onClick}>
        {content}
      </button>
    );
  }

  return <div className={wrapCls}>{content}</div>;
}
